import React from "react";
import { CheckOutlined, CloseOutlined, DollarOutlined, RightOutlined } from "@ant-design/icons";

function Fact({ children }) {
  if (children == null || children === "") return null;
  return <span className="listing-card__fact">{children}</span>;
}

function formatDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleDateString();
}

export function StandardTariffListingCard({ record, onClick }) {
  const name = record?.tariff_name ?? record?.name ?? "—";
  const category = record?.category_name ?? (record?.category_id != null ? `Category ${record.category_id}` : null);
  const active = record?.is_active != null ? Boolean(record.is_active) : null;
  const itemsCount = record?.items_count;

  return (
    <article
      className="listing-card listing-card--linear standard-tariff-listing-card"
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick() : undefined}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="listing-card__lead">
        <div className="listing-card__icon is-tariff" aria-hidden>
          <DollarOutlined />
        </div>
        <div className="listing-card__identity">
          <h3 className="listing-card__title">{name}</h3>
          <p className="listing-card__meta">{category || "Standard tariff"}</p>
        </div>
      </div>

      <div className="listing-card__facts">
        <Fact>{itemsCount != null ? `${Number(itemsCount).toLocaleString()} items` : null}</Fact>
        <Fact>{formatDate(record?.effective_date) ? `Effective ${formatDate(record.effective_date)}` : null}</Fact>
        <Fact>{formatDate(record?.expiry_date) ? `Expires ${formatDate(record.expiry_date)}` : null}</Fact>
        {record?.scope_state ? <Fact>{record.scope_state}</Fact> : null}
      </div>

      <div className="listing-card__aside">
        {active != null ? (
          <span className={`listing-card__status ${active ? "is-active" : "is-inactive"}`}>
            {active ? <CheckOutlined /> : <CloseOutlined />}
            {active ? "Active" : "Inactive"}
          </span>
        ) : null}
        {onClick ? <RightOutlined className="listing-card__chevron" aria-hidden /> : null}
      </div>
    </article>
  );
}

export default StandardTariffListingCard;
